// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wo9S","field":"styles_field__3VX51","fieldCol":"styles_fieldCol__RprG1","diffCol":"styles_diffCol__1ZJPS","diff":"styles_diff__zp5OP"};